<template>
  <ControlCommonLayout header="controlHeader" footer="controlFooter">
    <b-overlay :show="overlayShow" rounded="sm">
      <div class="container">
        <div class="main-color text-light row mt-3">
          <div class="col p-2">
            商品検索
          </div>
        </div>

        <div id="search-box" class="row mt-3 base-color">
          <div class="accordion col p-0" role="tablist">
            <b-card no-body>
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button block v-b-toggle.accordion-1 id='search-bar' class="light-blue text-left text-black" @click="changeIcon()"><b-icon id="icon-up" icon="chevron-up"></b-icon><b-icon id="icon-down" class="hide" icon="chevron-down"></b-icon>&nbsp;検索条件</b-button>
              </b-card-header>
              <!-- 制作案件一覧検索BOX -->
              <b-collapse visible id="accordion-1" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <form method="post" action="#" class="form-horizontal">
                    <div class="text-left mb-3" >
                      <b-button variant="secondary" type="button" class="w-5 white-btn" @click="goBack()">戻る</b-button>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-3">
                        <label for="name" class="control-label col-sm-12">商品コード</label>
                        <div class="col-sm-12 pr-0">
                          <input type="text" id="item-code" class="form-control input-sm search-item-condition" v-model="searchItemCode"/>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <label for="name" class="control-label col-sm-12">大区分</label>
                        <div class="col-sm-12 pr-0">
                          <select id="item-sectionL" class="form-control input-sm search-item-condition" v-model="searchSectionL">
                            <option value="">選択してください</option>
                            <option v-for="(sectionL, index) in getSectionL()" :key="index + 'sectionL'" :value="sectionL">{{sectionL}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <label for="name" class="control-label col-sm-12">中区分</label>
                        <div class="col-sm-12 pr-0">
                          <select id="item-sectionM" class="form-control input-sm search-item-condition" v-model="searchSectionM">
                            <option value="">選択してください</option>
                            <option v-for="(sectionM, index) in getSectionM()" :key="index + 'sectionM'" :value="sectionM">{{sectionM}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <label for="name" class="control-label col-sm-12">小区分</label>
                        <div class="col-sm-12 pr-0">
                          <select id="item-sectionS" class="form-control input-sm search-item-condition" v-model="searchSectionS">
                            <option value="">選択してください</option>
                            <option v-for="(sectionS, index) in getSectionS()" :key="index + 'sectionS'" :value="sectionS">{{sectionS}}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-3">
                        <label for="name" class="control-label col-sm-12">商品名</label>
                        <div class="col-sm-12 pr-0">
                          <input type="text" id="item-name" class="form-control input-sm search-item-condition" v-model="searchItemName"/>
                        </div>
                      </div>
                      <div class="col-sm-5 pr-0">
                        <div class="row" style="margin-left: 0px">
                          <label class="control-label col-sm-12">商品登録日時</label>
                          <div class="col-sm-5 pr-0">
                            <input type="date" id="item-make-date-from" class="form-control input-sm search-item-condition" v-model="searchItemMakeDateFrom"/>
                          </div>
                          <div class="col-sm-1 p-0 mt-2 text-center">
                            <span>〜</span>
                          </div>
                          <div class="col-sm-5 pl-0">
                            <input type="date" id="item-make-date-to" class="form-control input-sm search-item-condition" v-model="searchItemMakeDateTo"/>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-5 pr-0">
                        <div class="row" style="margin-left: 0px">
                          <label class="control-label col-sm-12">商品単価</label>
                          <div class="col-sm-5 pr-0">
                            <input type="text" id="item-price-from" class="form-control input-sm search-item-condition" v-model="searchItemPriceFrom"/>
                          </div>
                          <div class="col-sm-1 p-0 mt-2 text-center">
                            <span>〜</span>
                          </div>
                          <div class="col-sm-5 pl-0">
                            <input type="text" id="item-price-to" class="form-control input-sm search-item-condition" v-model="searchItemPriceTo"/>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="text-center mt-4">
                      <b-button variant="outline-secondary" type="button" class="w-25 white-btn" @click="clearConditions">検索条件をクリア</b-button>
                      <b-button class="main-color text-light w-25 ml-3" @click="searchItem()">検索</b-button>
                    </div>
                  </form>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>

        <!-- 商品一覧リスト -->
        <div class="row mt-3 base-color">
          <b-overlay :show="overlayitemListShow" rounded="sm" class="col-sm-12">
            <div class="col-sm-12 mt-3">
              <b-button variant="primary" @click="itemSelect()">商品決定</b-button>
            </div>
            <div class="col-sm-12 row pt-3 pr-0">
              <div class="col-sm-6">
                検索結果<span class="h3 ml-1">{{this.itemLength}}</span><span class="ml-1 mr-2">件</span>{{itemLength > 0 ? pageStart + 1 : 0}} - {{pageEnd}}件を表示
              </div>
            </div>
            <div class="col-sm-12 mt-3">
              <b-table-simple bordered class="small">
                <thead role="rowgroup" class="table-bordered">
                  <tr role="row" class="align-middle">
                    <th rowspan="1" class="align-middle text-center" style="width: 5%;"></th>
                    <th rowspan="1" class="align-middle text-center" style="width: 10%;" @click="sortBy('商品コード')">商品コード{{strSortDirection('商品コード')}}</th>
                    <th rowspan="1" class="align-middle text-center" style="width: 15%;" @click="sortBy('大区分')">大区分{{strSortDirection('大区分')}}</th>
                    <th rowspan="1" class="align-middle text-center" style="width: 15%;" @click="sortBy('中区分')">中区分{{strSortDirection('中区分')}}</th>
                    <th rowspan="1" class="align-middle text-center" style="width: 15%;" @click="sortBy('小区分')">小区分{{strSortDirection('小区分')}}</th>
                    <th rowspan="1" class="align-middle text-center" style="width: 30%;" @click="sortBy('商品名')">商品名{{strSortDirection('商品名')}}</th>
                    <th rowspan="1" class="align-middle text-center" style="width: 10%;" @click="sortBy('商品単価', 'num')">商品単価{{strSortDirection('商品単価')}}</th>
                  </tr>
                </thead>
                <template v-for="(item, index) in activeItemList">
                  <b-tbody :key="index + 'tbody'" :class="index % 2 === 1 ? 'gray-line' : 'white-line'">
                    <b-tr :key="index + 'item'">
                      <b-td class="align-middle" style="text-align: center;">
                        <input class="check-input" type="checkbox" :id="'check' + index" name="check" data-param-name="check" v-model="item['check']">
                      </b-td>
                      <b-td class="align-middle">{{item['商品コード'] ? item['商品コード']['value'] : ''}}</b-td>
                      <b-td class="align-middle">{{item['大区分'] ? item['大区分']['value'] : ''}}</b-td>
                      <b-td class="align-middle">{{item['中区分'] ? item['中区分']['value'] : ''}}</b-td>
                      <b-td class="align-middle">{{item['小区分'] ? item['小区分']['value'] : ''}}</b-td>
                      <b-td class="align-middle">{{item['商品名'] ? item['商品名']['value'] : ''}}</b-td>
                      <b-td class="align-middle">{{item['商品単価'] ? item['商品単価']['value'] : ''}}</b-td>
                    </b-tr>
                  </b-tbody>
                </template>
              </b-table-simple>
            </div>
            <div class="col-sm-12 row pt-3 pr-0">
              <div class="col-sm-4">
                検索結果<span class="h3 ml-1">{{this.itemLength}}</span><span class="ml-1 mr-2">件</span>{{itemLength > 0 ? pageStart + 1 : 0}} - {{pageEnd}}件を表示
              </div>
              <div class="col-sm-4">
                <paginate
                  v-model="page"
                  :page-count="Math.ceil(itemLength / pageMaxNum)"
                  :page-range="3"
                  :margin-pages="2"
                  :click-handler="clickCallback"
                  :prev-text="'<'"
                  :next-text="'>'"
                  :container-class="'pagination justify-content-center'"
                  :page-class="'page-item'"
                  :page-link-class="'page-link'"
                  :prev-class="'page-item'"
                  :prev-link-class="'page-link'"
                  :next-class="'page-item'"
                  :next-link-class="'page-link'"
                  >
                </paginate>
              </div>
            </div>
          </b-overlay>
        </div>

      </div>
    </b-overlay>
    <CommonModal ref="commonModal" />
  </ControlCommonLayout>
</template>
<script>
import ControlCommonLayout from '@/layout/ControlCommonLayout'
import CommonModal from '@/components/CommonModal'
import CategoryListModel from '@/models/CategoryListModel'
import SearchItemModel from '@/models/SearchItemModel'

export default {
  name: 'ControlItemSearch',
  components: { ControlCommonLayout, CommonModal, CategoryListModel, SearchItemModel },
  data () {
    return {
      overlayShow: false,
      overlayitemListShow: false,
      searchItemCode: '',
      searchSectionL: '',
      searchSectionM: '',
      searchSectionS: '',
      searchItemName: '',
      searchItemMakeDateFrom: '',
      searchItemMakeDateTo: '',
      searchItemPriceFrom: '',
      searchItemPriceTo: '',
      sectionLList: [],
      sectionMList: [],
      sectionSList: [],
      userId: '',
      toroku: false,
      activeItemList: [],
      itemData: [],
      itemLength: 0,
      page: 1,
      pageMaxNum: 100,
      pageStart: 0,
      pageEnd: 0,
      itemCodeSortDirection: '',
      sectionLSortDirection: '',
      sectionMSortDirection: '',
      sectionSSortDirection: '',
      itemNameSortDirection: '',
      itemPriceSortDirection: ''
    }
  },
  methods: {
    setApiData: async function (isReload = false) {
      this.overlayShow = true
      console.log(this.$route.meta)
      console.log(this.$route.query)
      if (this.$route.meta.userId) {
        this.userId = this.$route.meta.userId
        localStorage.setItem('controlUserId', this.userId)
      } else {
        this.userId = localStorage.getItem('controlUserId')
      }
      if (this.$route.meta.userId) {
        this.toroku = (this.$route.meta.toroku === 'true')
        localStorage.setItem('controlToroku', JSON.stringify(this.toroku))
      } else {
        this.toroku = (localStorage.getItem('controlToroku') === 'true')
      }
      console.log(this.userId)
      console.log(this.toroku)

      const CategoryListResult = await CategoryListModel.getApi(this.$bvModal, {}, () => {})
      console.log(CategoryListResult)
      this.sectionLList = CategoryListResult['大分類']
      this.sectionMList = CategoryListResult['中分類']
      this.sectionSList = CategoryListResult['小分類']

      scrollTo(0, 0)

      this.overlayShow = false
    },
    toCommaSeparated (str) {
      if (str) {
        try {
          return parseInt(str, 10).toLocaleString()
        } catch (err) {
          return ''
        }
      }
      return str
    },
    changeDateFormat (date) {
      if (date === null) {
        return null
      }

      date = date.replace('T', ' ').replace('Z', ' ').replace('-', '/').replace('-', '/')
      return date
    },
    changeIcon () {
      document.getElementById('icon-up').classList.toggle('hide')
      document.getElementById('icon-down').classList.toggle('hide')
    },
    getSectionL () {
      return this.sectionLList
    },
    getSectionM () {
      return this.sectionMList
    },
    getSectionS () {
      return this.sectionSList
    },
    setItems: async function () {
      // 画面に表示している一覧をクリア
      this.activeItemList = []
      // 検索結果を初期化
      this.resetItems()
      // 検索条件を初期化
      this.clearConditions()
      // 1ページ目を表示
      this.page = 1
    },
    clearConditions () {
      this.searchItemCode = ''
      this.searchSectionL = ''
      this.searchSectionM = ''
      this.searchSectionS = ''
      this.searchItemName = ''
      this.searchItemMakeDateFrom = ''
      this.searchItemMakeDateTo = ''
      this.searchItemPriceFrom = ''
      this.searchItemPriceTo = ''
    },
    resetItems () {
      this.itemData = []
      this.itemLength = 0
      this.pageStart = 0
      this.pageEnd = 0
    },
    setActiveItemList: async function () {
      this.pageStart = (this.page - 1) * this.pageMaxNum
      // pageが大きすぎる場合は表示可能になるまで減らす
      for (;this.page > 0;) {
        if (this.itemLength < this.pageStart) {
          this.page -= 1
          this.pageStart = (this.page - 1) * this.pageMaxNum
        } else {
          break
        }
      }

      this.pageEnd = this.pageStart + this.pageMaxNum
      if (this.itemLength < this.pageEnd) {
        this.pageEnd = this.pageStart + (this.itemLength % this.pageMaxNum)
      }
      this.activeItemList = this.itemData['records'].slice(this.pageStart, this.pageEnd)

      localStorage.setItem('nowItemListPage', this.page)
    },
    clickCallback (pageNum) {
      this.page = pageNum // pageNumはpagerの何番目をclickしたかを取得
      this.setActiveItemList()
      this.sortKeep()
    },
    validate () {
      // 検索条件のチェックを追加する
      return true
    },
    searchItem: async function (nowpage = 1) {
      if (!this.validate()) {
        return false
      }
      this.page = nowpage
      this.overlayitemListShow = true

      let params = {}
      if (this.searchItemCode !== '') {
        params['itemCode'] = this.searchItemCode
      }
      if (this.searchSectionL !== '') {
        params['sectionL'] = this.searchSectionL
      }
      if (this.searchSectionM !== '') {
        params['sectionM'] = this.searchSectionM
      }
      if (this.searchSectionS !== '') {
        params['sectionS'] = this.searchSectionS
      }
      if (this.searchItemName !== '') {
        params['itemName'] = this.searchItemName
      }
      if (this.searchItemMakeDateFrom !== '') {
        params['makeDateFrom'] = this.searchItemMakeDateFrom
      }
      if (this.searchItemMakeDateTo !== '') {
        params['makeDateTo'] = this.searchItemMakeDateTo
      }
      if (this.searchItemPriceFrom !== '') {
        params['priceFrom'] = this.searchItemPriceFrom
      }
      if (this.searchItemPriceTo !== '') {
        params['priceTo'] = this.searchItemPriceTo
      }

      let itemData = await SearchItemModel.getApi(this.$bvModal, params, () => {})
      console.log(itemData)
      if (!itemData['records'] || itemData['status'] !== 'success') {
        console.log('商品情報検索失敗')
        this.$refs.commonModal.msgBoxOk('商品情報の検索に失敗いたしました。')
        this.overlayitemListShow = false
        return false
      }
      this.itemData = itemData

      // 検索条件を保存
      let searchConditions = {}
      this.itemLength = this.itemData['records'].length
      this.setActiveItemList()

      // 画面項目の検索条件を保存
      const searchInputs = document.getElementsByClassName('search-item-condition')
      for (const searchInput of searchInputs) {
        searchConditions[searchInput.id] = searchInput.value
      }
      localStorage.setItem('searchItemConditions', JSON.stringify(searchConditions))

      // チェック情報を初期化
      for (let i = 0; i < this.itemData.length; i++) {
        itemData[i]['check'] = ''
      }
      console.log(this.itemData)

      // ソートを初期化
      this.iniSortDirection()

      this.overlayitemListShow = false
    },
    itemSelect () {
      if (this.itemLength === 0) {
        console.log('商品情報未検索')
        this.$refs.commonModal.msgBoxOk('商品情報を検索してください。')
        return false
      }
      // 商品決定時の処理を記載
      let addSpecRegistrationItems = []
      addSpecRegistrationItems = this.itemData['records'].filter(o => o.check)
      if (addSpecRegistrationItems.length === 0) {
        console.log('商品情報未選択')
        this.$refs.commonModal.msgBoxOk('商品情報を1行以上選択してください。')
        return false
      }
      localStorage.setItem('addSpecRegistrationItems', JSON.stringify(addSpecRegistrationItems))
      // 戻るフラグ
      localStorage.setItem('isPageBack', JSON.stringify(true))
      // 呼び出し元の画面に戻る
      this.$router.back()
    },
    goBack () {
      // 戻るフラグ
      localStorage.setItem('isPageBack', JSON.stringify(true))
      // 呼び出し元の画面に戻る
      this.$router.back()
    },
    sortSet (key, sortType = 'asc', type = 'str') {
      this.overlayitemListShow = true

      let itemList = this.activeItemList
      this.activeItemList = []
      setTimeout(() => {
        let trueSort = 1 // 降順ソート
        let folseSort = -1 // 降順ソート
        if (sortType !== 'desc') {
          trueSort = -1 // 昇順ソート
          folseSort = 1 // 昇順ソート
        }
        if (type === 'num') {
          itemList = itemList.sort(function (a, b) {
            return (Number(a[key]['value']) < Number(b[key]['value'])) ? trueSort : folseSort
          })
        } else {
          itemList = itemList.sort(function (a, b) {
            return (a[key]['value'] < b[key]['value']) ? trueSort : folseSort
          })
        }
      }, 100)
      this.activeItemList = itemList
      this.overlayitemListShow = false
    },
    sortBy (key, type = 'str') {
      this.iniSortDirection(key)
      this.sortSet(key, this.getSortDirection(key), type)
    },
    sortKeep () {
      if (this.itemCodeSortDirection !== '') {
        this.sortSet('商品コード', this.itemCodeSortDirection)
      }
      if (this.sectionLSortDirection !== '') {
        this.sortSet('大区分', this.sectionLSortDirection)
      }
      if (this.sectionMSortDirection !== '') {
        this.sortSet('中区分', this.sectionMSortDirection)
      }
      if (this.sectionSSortDirection !== '') {
        this.sortSet('小区分', this.sectionSSortDirection)
      }
      if (this.itemNameSortDirection !== '') {
        this.sortSet('商品名', this.itemNameSortDirection)
      }
      if (this.itemPriceSortDirection !== '') {
        this.sortSet('商品単価', this.itemPriceSortDirection, 'num')
      }
    },
    getSortDirection (key) {
      if (key === '商品コード') {
        if (this.itemCodeSortDirection !== 'desc') {
          this.itemCodeSortDirection = 'desc'
        } else {
          this.itemCodeSortDirection = 'asc'
        }
        return this.itemCodeSortDirection
      }
      if (key === '大区分') {
        if (this.sectionLSortDirection !== 'desc') {
          this.sectionLSortDirection = 'desc'
        } else {
          this.sectionLSortDirection = 'asc'
        }
        return this.sectionLSortDirection
      }
      if (key === '中区分') {
        if (this.sectionMSortDirection !== 'desc') {
          this.sectionMSortDirection = 'desc'
        } else {
          this.sectionMSortDirection = 'asc'
        }
        return this.sectionMSortDirection
      }
      if (key === '小区分') {
        if (this.sectionSSortDirection !== 'desc') {
          this.sectionSSortDirection = 'desc'
        } else {
          this.sectionSSortDirection = 'asc'
        }
        return this.sectionSSortDirection
      }
      if (key === '商品名') {
        if (this.itemNameSortDirection !== 'desc') {
          this.itemNameSortDirection = 'desc'
        } else {
          this.itemNameSortDirection = 'asc'
        }
        return this.itemNameSortDirection
      }
      if (key === '商品単価') {
        if (this.itemPriceSortDirection !== 'desc') {
          this.itemPriceSortDirection = 'desc'
        } else {
          this.itemPriceSortDirection = 'asc'
        }
        return this.itemPriceSortDirection
      }
    },
    iniSortDirection (key = '') {
      if (key !== '商品コード') {
        this.itemCodeSortDirection = ''
      }
      if (key !== '大区分') {
        this.sectionLSortDirection = ''
      }
      if (key !== '中区分') {
        this.sectionMSortDirection = ''
      }
      if (key !== '小区分') {
        this.sectionSSortDirection = ''
      }
      if (key !== '商品名') {
        this.itemNameSortDirection = ''
      }
      if (key !== '商品単価') {
        this.itemPriceSortDirection = ''
      }
    },
    strSortDirection (key) {
      let keysort = ''
      if (key === '商品コード') {
        keysort = this.itemCodeSortDirection
      } else if (key === '大区分') {
        keysort = this.sectionLSortDirection
      } else if (key === '中区分') {
        keysort = this.sectionMSortDirection
      } else if (key === '小区分') {
        keysort = this.sectionSSortDirection
      } else if (key === '商品名') {
        keysort = this.itemNameSortDirection
      } else if (key === '商品単価') {
        keysort = this.itemPriceSortDirection
      }
      if (keysort === 'asc') {
        return ' ▲'
      }
      if (keysort === 'desc') {
        return ' ▼'
      }
      return ''
    }
  },
  mounted () {
    this.setApiData()
  }
}
</script>
<style>
.check-input {
  width:20px;
  height:20px;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/pages/ControlItemSearch.vue